import VideoTile from '@components/VideoTile';
import styled from '@emotion/styled';

export const RemoteVideoAria = styled.div`
  display: flex;
`;

export const RemoteVideoContainer = styled(VideoTile)<{ size?: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ size }) => (size === 2 ? '100%' : 'fit-content')};
  aspect-ratio: ${({ size }) => (size === 2 ? '4/3' : undefined)};
  margin: 0;
  background-color: #161616;
  border-radius: 4px;
`;
